module.exports = __webpack_public_path__ + "img/spotify.22350618.svg";